import { render, staticRenderFns } from "./AdminAdvertisers.vue?vue&type=template&id=0134db52&scoped=true"
import script from "./AdminAdvertisers.vue?vue&type=script&lang=js"
export * from "./AdminAdvertisers.vue?vue&type=script&lang=js"
import style0 from "./AdminAdvertisers.vue?vue&type=style&index=0&id=0134db52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0134db52",
  null
  
)

export default component.exports